import React from 'react';
import { Layout } from 'antd';
import { Route, useRouteMatch, Switch, Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { AuthRoutes } from './auth.routes';
import {
  ContentComponent,
  NotFoundPageComponent,
  StoreStateInterface,
  UserRoleEnum,
} from '../../../common';
import LoginPageComponent from '../login/loginPage.component';
import RegisterPageComponent from '../register/registerPage.component';
import ForgotPasswordPageComponent from '../forgotPassword/forgotPassword.component';
import { AppRoutes } from '../../app';
import { AdminRoutes } from '../../admin';

function AuthRouter() {
  const userAuth = useSelector((state: StoreStateInterface) => state.auth);
  const isAdmin = userAuth?.user?.roles === UserRoleEnum.ADMIN;

  const { path } = useRouteMatch();

  if (userAuth && userAuth.isAuthenticated) {
    return <Redirect to={isAdmin ? AdminRoutes.DASHBOARD.fullPath : AppRoutes.DASHBOARD.fullPath} />;
  }

  let routes = [
    {
      path: AuthRoutes.LOGIN.path,
      component: LoginPageComponent,
      roles: [],
      exact: true,
    },
    {
      path: AuthRoutes.REGISTER.path,
      component: RegisterPageComponent,
      roles: [],
      exact: true,
    },
    {
      path: AuthRoutes.FORGOT_PASSWORD.path,
      component: ForgotPasswordPageComponent,
      roles: [],
      exact: true,
    },
  ];

  return (
    <Layout className="layout auth">
      <ContentComponent className="content site-container">
        <Switch>
          {routes.map((route, index) => (
            <Route exact={route.exact} path={`${path}/${route.path}`} key={index}>
              {' '}
              <route.component />{' '}
            </Route>
          ))}
          <Route component={NotFoundPageComponent} />
        </Switch>
      </ContentComponent>
    </Layout>
  );
}

export default AuthRouter;
